export default {
  route: {
    getLocationErr: '获取位置信息失败',
    backHome: '返回首页',
    changePassword: '修改密码',
    logOut: '退出登录',
    switchAccount: '切换账号'
  },
  navbar: {
  },
  login: {
    title: '系统登录',
    logIn: '登录',
    username: '账号',
    password: '密码',
    message: '为获得更好的系统体验，请使用Google Chrome浏览器！',
    adPasswordErr: '域账号密码错误，请重新输入'
  },
  documentation: {
  },
  permission: {
  },
  guide: {
  },
  components: {
  },
  table: {
    orderCancle:'取消订单',
    add: '新增',
    export: '导出',
    import: '导入',
    download: '下载导入模板',
    id: '序号',
    actions: '操作',
    edit: '编辑',
    delete: '删除',
    input: '请输入',
    select: '请选择',
    close: '关闭',
    save: '保存',
    submit: '提交',
    switch: '切换',
    cancle: '取消',
    sure:'确认',
    yes: '是',
    no: '否',
    failure: '失效',
    view: '查看',
    logistics: '物流信息',
    onlineContact: '在线联系',
    abnormalReport: '差异上报',
    abnormalEdit: '差异编辑',
    abnormalDetail: '差异处理详情',
    orderDetail: '订单明细',
    userDetail: '用户信息',
    diffApprove: '差异审批',
    upload: '文件上传',
    editBoxNumber: '修改箱数',
    editAddress: '修改地址',
    orderList: '订单列表',
    authManger: '权限管理',
    uploadReceipt: '上传回单',
    previewReceipt: '回单预览',
    taxRateTable: '税率表',
    brandEmailTable:'品牌运营邮箱维护',
    qrCodeLog: 'QR开关日志',
    choiceTruck: '选择运输车辆',
    carrierList: '运输商列表',
    brandCounterRoleList:'品牌柜台角色',
    counterBrandEmail: '主管预警邮箱配置',
    accountList: '账号列表',
    brandName: '品牌',
    counterCode: '柜台编码',
    counterName: '柜台名称',
    roleName: '角色',
    doList: '货单列表',
    eventHandled: '事件关闭',
    processSubmission: '处理提交',
    transferReqSkuDetail: '调柜需求明细',
    applyDetail: '调柜申请详情',
    applyEdit: '调柜申请编辑',
    approveReturn:'审批拒绝',
    totalQuantity: '总数量',
    totalWeight: '总重量',
    totalVolume: '总体积',
  },
  upload: {
    imgUpload: '图片上传',
    fileUpload: '文件上传',
    importFile: '导入文件',
    chioseFile: '选取文件',
    send: '上传',
    downTemplate: '下载模板'
  },
  onlineContact: {
    send: '发送',
    tip: '请输入聊天内容'
  },
  week: {
    monday: '周一',
    tuesday: '周二',
    wednesday: '周三',
    thursday: '周四',
    friday: '周五',
    saturday: '周六',
    sunday: '周日',
  },
  date: {
    startDate: '开始日期',
    endDate: '结束日期',
    startTime: '开始时间',
    endTime: '结束时间',
    to: '至'
  },
  errorLog: {
    documentation: '文档介绍'
  },
  excel: {
    tip: '提示：导入仅支持xlsx/xls格式的文件',
  },
  zip: {
  },
  pdf: {
  },
  image: {
    tip: '提示：必须选择后缀.jpg或.png图片文件(图片命名：订单号_001.jpg，订单号_002.jpg)'
  },
  theme: {
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  comm: {
    success: '成功',
    deleteMsg: '确认删除选中记录吗？',
    createTime: '创建时间',
    creator: '创建者',
    updateTime: '更新时间',
    updater: '更新者',
    reset: '重置',
    search: '搜索'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js